import { bind } from "@react-rxjs/core"
import { defer, distinctUntilChanged, map, retry, shareReplay, tap } from "rxjs"

import { ERROR_ACCOUNT_SUMMARY_RESULT } from "@/generated/TradingGateway"
import { withConnection } from "@/services/withConnection"

import { clearEquitiesError, publishEquitiesError } from "../errorAlert"
import {
  AccountService,
  type AccountSummary,
  type AccountSummaryResult,
} from "../TradingGateway"

const accountSummaryResponses$ = defer(() =>
  AccountService.getAccountSummary(),
).pipe(
  tap({
    error: (err) => {
      const humanMessage = (
        err instanceof Error ? err.message : String(err)
      ).trim()
      console.error("[account] Hydra stream error:", err)
      publishEquitiesError({
        source: "account",
        message: `Error fetching account summary. ${humanMessage}`,
      })
    },
  }),
  retry({ delay: 1_000 }),
  shareReplay(1),
)

export const [useAccountSummary, accountSummary$] = bind(
  accountSummaryResponses$.pipe(
    withConnection(),
    map((response: AccountSummaryResult) => {
      if (response.type === ERROR_ACCOUNT_SUMMARY_RESULT) {
        console.error(
          "[account] Server-returned error:",
          response.payload.message,
        )
        publishEquitiesError({
          source: "account",
          message: response.payload.message,
        })
        return {
          accountNumber: "",
          cash: "0",
          portfolioValue: "0",
          buyingPower: "0",
        } satisfies AccountSummary
      }
      clearEquitiesError("account")
      return response.payload.payload
    }),
    distinctUntilChanged(
      (prev, curr) =>
        prev.cash === curr.cash &&
        prev.buyingPower === curr.buyingPower &&
        prev.portfolioValue === curr.portfolioValue,
    ),
  ),
)
